// extracted by mini-css-extract-plugin
export default {"table":"styles-module__table__src-labstep-web-components-Molecule-StoichiometryTable-_uY7Z4"};